import LocationsPage from 'src/dispensary/core-menu/locations';
import { getDispensaryServerSideProps } from 'src/utils/ssr/get-dispensary-server-side-props';

export const getServerSideProps = getDispensaryServerSideProps;

export default LocationsPage;
